import { SHOW_CREATE_SUB_OBJECTIVE_MODAL, HIDE_CREATE_SUB_OBJECTIVE_MODAL } from './actionTypes';

export const showCreateSubObjectiveModalAction = () => ({
  type: SHOW_CREATE_SUB_OBJECTIVE_MODAL,
});

export const hideCreateSubObjectiveModalAction = () => ({
  type: HIDE_CREATE_SUB_OBJECTIVE_MODAL,
});
